export default __webpack_public_path__ + "static/selfapp-self-text-mobile-9915d133d8ba47ba04619712c82d7bbd.jpg";